import { MtUser, MtAccount } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import { UserFilters, AccountFilters } from "client/store"
import * as types from "./types"


export const setAccountUserList = (accountUserList: types.AccountUserList) => ({
    type: inferLiteral(types.ACCOUNT_USER_LIST),
    accountUserList,
})
export const setUserAccountList = (userAccountList: types.UserAccountList) => ({
    type: inferLiteral(types.USER_ACCOUNT_LIST),
    userAccountList,
})

// account users

export const setAssignedAccountUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.ASSIGNED_ACCOUNT_USER_IDS),
    userIds,
})
export const setAssignedAccountUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.ASSIGNED_ACCOUNT_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setAssignedAccountUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.ASSIGNED_ACCOUNT_USER_FILTERS),
    filters,
})
export const setNotAssignedAccountUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_ACCOUNT_USER_IDS),
    userIds,
})
export const setNotAssignedAccountUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_ACCOUNT_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedAccountUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_ACCOUNT_USER_FILTERS),
    filters,
})
export const setNotAssignedAccountUserSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_ACCOUNT_USER_SELECTED),
    selected,
})

// user accounts

export const setAssignedUserAccountIds = (accountIds: readonly number[]) => ({
    type: inferLiteral(types.ASSIGNED_USER_ACCOUNT_IDS),
    accountIds,
})
export const setAssignedUserAccountSort = (sortColumn: keyof MtAccount, sortOrder: OrderType) => ({
    type: inferLiteral(types.ASSIGNED_USER_ACCOUNT_SORT),
    sortColumn,
    sortOrder,
})
export const setAssignedUserAccountFilters = (filters: AccountFilters) => ({
    type: inferLiteral(types.ASSIGNED_USER_ACCOUNT_FILTERS),
    filters,
})
export const setNotAssignedUserAccountIds = (accountIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_USER_ACCOUNT_IDS),
    accountIds,
})
export const setNotAssignedUserAccountSort = (sortColumn: keyof MtAccount, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_USER_ACCOUNT_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedUserAccountFilters = (filters: AccountFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_USER_ACCOUNT_FILTERS),
    filters,
})
export const setNotAssignedUserAccountSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_USER_ACCOUNT_SELECTED),
    selected,
})

// reload lists

export const setAccountUserReloadList = (value: boolean) => ({
    type: inferLiteral(types.ACCOUNT_USER_RELOAD_LIST),
    value,
})
export const setUserAccountReloadList = (value: boolean) => ({
    type: inferLiteral(types.USER_ACCOUNT_RELOAD_LIST),
    value,
})
